import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ToastComponent from "../Common/TaostComponent";
import CommonService from "../../services/common.service";
const API_URL = process.env.REACT_APP_API_URL;

const ProMemberSuccess = () => {
  const location = useLocation();
  const [sessionDetails, setSessionDetails] = useState(null);
  const sessionId = new URLSearchParams(location.search).get("session_id");
  const navigate = useNavigate();
  const sub_type = localStorage.getItem("sub_type");
  useEffect(() => {
    if (sessionId) {
      const data = {};
      data.session_id = sessionId; // or token: paymentMethod.id for older versions
      data.sub_type = sub_type;
      CommonService.saveUserPremium(data)
        .then((res) => {
          if (res.success) {
            if (res.userPremimium) {
              localStorage.setItem(
                "userPremimium",
                JSON.stringify(res.userPremimium)
              );
            }
            if (res.is_submit) {
              if (res.receipt_url) {
                fetch(res.receipt_url, {
                  method: "GET",
                  headers: {
                    "Content-Type": "application/pdf",
                  },
                })
                  .then((response) => response.blob())
                  .then((blob) => {
                    // Create a temporary link and trigger a click to initiate the download
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(blob);
                    link.download = "receipt.pdf";
                    link.style.display = "none";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  })
                  .catch((error) =>
                    console.error("Error downloading PDF:", error)
                  );
              }
              ToastComponent(
                "Payment confirmed! MCT PRO Membership activated",
                "success"
              );
              navigate("/dashboard");
            } else {
              ToastComponent(
                "Something went wrong. Please try again.",
                "success"
              );
            }
          } else {
            ToastComponent(res.message, "error");
          }
        })
        .catch((e) => {
          console.log("Error", e);
        });
    }
  }, [sessionId]);

  return (
    <div>
      {sessionDetails ? (
        <div>
          <h1>Payment Successful</h1>
          <p>Thank you for your payment, {sessionDetails.customer.name}!</p>
          <p>Your payment ID is {sessionDetails.session.payment_intent}.</p>
        </div>
      ) : (
        <p>Processing...</p>
      )}
    </div>
  );
};

export default ProMemberSuccess;
